export default "__VITE_ASSET__Ey7AgtVp__"